const PAIN_POINTS = [
  {
    icon: 'ri-user-unfollow-line',
    title: 'Not Getting Enough Leads?',
    body: 'You do great work but the phone isn\'t ringing. Most contractors struggle to get a steady flow of new customers — not because of their skills, but because their ads aren\'t reaching the right people.',
    stat: '68% of contractors',
    statLabel: 'say lead generation is their #1 challenge',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Wasting Money on Ads That Don\'t Work?',
    body: 'You\'ve tried boosting posts or running Google ads, but the results are disappointing. Bad ad copy and wrong targeting burn your budget fast — with nothing to show for it.',
    stat: '$4,200 avg.',
    statLabel: 'wasted per year on ineffective contractor advertising',
  },
  {
    icon: 'ri-time-line',
    title: 'No Time or Experience with Marketing?',
    body: 'You\'re on the job site all day. You don\'t have hours to learn Facebook Ads Manager or write copy. Marketing feels like a second job you never signed up for.',
    stat: '5+ hours/week',
    statLabel: 'lost trying to manage ads manually',
  },
];

export default function ContractorPainPoints() {
  return (
    <section className="py-20 lg:py-24 bg-stone-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-400 uppercase tracking-widest mb-3">
            Sound Familiar?
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-white mb-4 leading-tight">
            The Real Problems Contractors Face with Advertising
          </h2>
          <p className="text-base text-stone-400 max-w-xl mx-auto">
            You didn&apos;t start your business to become a marketer. But without good ads, growth stalls.
            Here&apos;s what most contractors deal with every day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PAIN_POINTS.map((point) => (
            <div
              key={point.title}
              className="bg-white/5 border border-white/10 rounded-2xl p-7 flex flex-col gap-4 hover:bg-white/8 transition-colors duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-500/20 text-orange-400">
                <i className={`${point.icon} text-2xl`} />
              </div>
              <h3 className="text-lg font-bold text-white leading-snug">{point.title}</h3>
              <p className="text-sm text-stone-400 leading-relaxed flex-1">{point.body}</p>
              <div className="pt-4 border-t border-white/10">
                <span className="text-xl font-black text-orange-400">{point.stat}</span>
                <p className="text-xs text-stone-500 mt-1">{point.statLabel}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-base text-stone-300 font-medium">
            AdForge fixes all three — in under 3 minutes.
          </p>
        </div>
      </div>
    </section>
  );
}
